// @ts-strict-ignore
import { BaseSingleConnectionConnectProcessor } from './base-single-connection-connect.processor';
import { ArticleContainerUtils } from '@3d-scene/model3d/util/article-container-utils';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { ArticleContainerPropertyDef } from '@article/constants/article-container-property-def';
import { CompositionContainer } from '@3d-scene/model3d/composition-container';
import { CompositeArticleUtils } from '@article/util/composite-article-utils';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { Connection } from '@3d-scene/model3d/connection';
import { ConnectionAreaVO } from '@shared/vo/meta-element.vo';
import { ConnectArticleHelper } from '@article/helper/connect-article.helper';
import { CompositeConnectionUtils } from '@project/components/article/util/composite-connection-utils';
import { Injectable } from '@angular/core';
import { ArticleContainerFactory } from '@3d-scene/model3d/article-container.factory';
import { ArticleManager } from '@article/manager/article.manager';
import { CompositeArticleCacheManager } from '@article/manager/composite-article-cache.manager';
import { ArticleContainerLoader } from '@article/service/article-container-loader';
import { ProjectModel } from '@project/model/project.model';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { ProjectModelService } from '@project/service/project-model.service';
import { ProjectArticleService } from '@project/service/project-article.service';
import { ProjectMetaElementService } from '@project/manager/project-meta-element.service';
import { DetachArticleUsageService } from '@project/service/detach-article-usage.service';
import { CompositeArticleInfoUtils } from '@article/util/composite-article-info-utils';

@Injectable({ providedIn: 'root' })
export class DefaultSingleConnectionConnectProcessor extends BaseSingleConnectionConnectProcessor {
  constructor(
    projectModel: ProjectModel,
    projectModelService: ProjectModelService,
    projectArticleService: ProjectArticleService,
    private projectMetaElementService: ProjectMetaElementService,
    articleContainerLoader: ArticleContainerLoader,
    compositeArticleCacheManager: CompositeArticleCacheManager,
    articleContainerFactory: ArticleContainerFactory,
    articleManager: ArticleManager,
    compositeArticleUtils: CompositeArticleUtils,
    compositeArticleInfoUtils: CompositeArticleInfoUtils,
    articleContainerUtils: ArticleContainerUtils,
    detachArticleUsageService: DetachArticleUsageService,
    private localeResourceManager: LocaleResourceManager,
    containerService: ContainerService,
  ) {
    super(
      projectModel,
      projectModelService,
      projectArticleService,
      articleContainerLoader,
      compositeArticleCacheManager,
      articleContainerFactory,
      articleManager,
      compositeArticleUtils,
      compositeArticleInfoUtils,
      articleContainerUtils,
      detachArticleUsageService,
      containerService,
    );
  }


  private getGivingConnectionCube(baseContainer: ArticleContainer, givingConnectionName: string): Connection {
    let givingCube: Connection = null;
    if (this.compositeArticleUtils.isCompositeMultipleBaseArticle(this.compositeArticleInfoUtils.getCompositeArticleFromContainer(baseContainer))) {
      givingCube = CompositeConnectionUtils.findConnectionCubeByCompositeConnectionName(givingConnectionName, [baseContainer]);
    } else {
      givingCube = baseContainer.findFirstConnectionByName(givingConnectionName);
    }
    return givingCube;
  }

  public process(
    containers: ArticleContainer[],
    baseContainer: ArticleContainer,
    givingConnectionAreas: ConnectionAreaVO[],
    rotationAngle: number
  ): void {
    const acceptingConnections: Connection[] = baseContainer.properties.getValue(ArticleContainerPropertyDef.ACCEPTING_CONNECTIONS);
    const givingConnection: ConnectionAreaVO = givingConnectionAreas[0];
    if (acceptingConnections && acceptingConnections.length > 0) {
      const acceptingConn: Connection = acceptingConnections[0];
      // get connector cube for giving area
      const givingCube: Connection = this.getGivingConnectionCube(baseContainer, givingConnection.name);
      if (givingCube && givingCube.compositionRectangle && acceptingConn && acceptingConn.compositionRectangle) {
        this.projectMetaElementService.createUsageBetweenConnections(givingCube, acceptingConn);
        ConnectArticleHelper.connectArticlesByCubes(containers, acceptingConn, givingCube);
        this.dispatchMessages(containers, acceptingConn);
      } else {
        throw new Error(this.localeResourceManager.getValueByKey('connectProcessor.message.unknown_connection', [givingConnection.name]));
      }
    } else {
      throw new Error(this.localeResourceManager.getValueByKey('connectProcessor.message.no_connection'));
    }
  }

  private dispatchMessages(givingContainers: ArticleContainer[], acceptingCube: Connection): void {
    const acceptingArticleContainer: ArticleContainer = this.containerService.getArticleContainer(acceptingCube);
    const compositionContainer: CompositionContainer = this.containerService.getCompositionContainer(acceptingArticleContainer);
    for (const container of givingContainers) {
      this.finalizeAttachContainer(
        compositionContainer.compositionGuid,
        container,
        ArticleUsageUtils.getBackwardConnectedConnectionUsageIds(container.articleUsage)
      );
    }
  }
}
